export default [
  {
    path: '/baccarat-live',
    name: 'baccarat-live',
    component: () => import('@/views/baccaratLive/Index.vue'),
    meta: {
      pageTitle: 'breadcrumb.baccaratLive',
      resource: 'baccarat-live',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.baccaratLive',
          active: true,
        },
      ],
    },
  },
]
